module.exports = __webpack_public_path__ + "img/avijit.2d48aa34.jpg";